module.exports = __webpack_public_path__ + "img/iv_logo.b3c93b9f.png";